import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkYes",
  "use": "icon-checkYes-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-checkYes\">\n<path d=\"M11 1.05078L9.05078 3H4C3.44772 3 3 3.44772 3 4V12C3 12.5523 3.44772 13 4 13H12C12.5523 13 13 12.5523 13 12V8.94922L14.9492 7H15V12C15 13.6569 13.6569 15 12 15H4C2.34315 15 1 13.6569 1 12V4C1 2.34315 2.34315 1 4 1H11V1.05078ZM15.207 3.20703L7.5 10.9141L3.79297 7.20703L5.20703 5.79297L7.5 8.08594L13.793 1.79297L15.207 3.20703Z\" fill=\"#242333\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol